import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=f9da9cba&scoped=true"
import script from "./placeholder.vue?vue&type=script&lang=ts"
export * from "./placeholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9da9cba",
  null
  
)

export default component.exports